@if (dtypeForm) {
  <dtype-component-list [dtypeForm]="dtypeForm" [isUpdate]="isUpdate">
  </dtype-component-list>
}